import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['change']

  switch(e) {
    e.preventDefault()

    $(this.changeTargets).toggleClass(this.data.get('hidden-class') ? this.data.get('hidden-class') : 'hidden')
  }
}
